var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":((_vm.$t('Configuration.name')) + " > " + (_vm.$t('Activity.title')))}}),_vm._v(" "),_c('div',{staticClass:"content-devx"},[_c('ActivitiesDatagrid',{attrs:{"activities":_vm.activities}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }